import { action, observable } from 'mobx';
import debounce from 'lodash.debounce';
import { CreateOrUpdateUserInput } from '../services/user/dto/createOrUpdateUserInput';
import { EntityDto } from '../services/dto/entityDto';
import { GetRoles } from '../services/user/dto/getRolesOuput';
import { GetUserOutput } from '../services/user/dto/getUserOutput';
import { PagedResultDto } from '../services/dto/pagedResultDto';
import { PagedUserResultRequestDto } from '../services/user/dto/PagedUserResultRequestDto';
import { UpdateUserInput } from '../services/user/dto/updateUserInput';
import userService from '../services/user/userService';
import { GetUserIdAndNameByRoleNameOutput, Int64EntityDto, UserServiceProxy } from '../services/serviceProxy';

class UserStore {
  private userServiceProxy: UserServiceProxy = new UserServiceProxy();

  @observable users!: PagedResultDto<GetUserOutput>;
  @observable editUser!: CreateOrUpdateUserInput;

  @observable roles: GetRoles[] = [];

  @observable userIdAndNamesByUserIds: GetUserIdAndNameByRoleNameOutput[] = [];
  @observable userIdAndNamesyLikeName: GetUserIdAndNameByRoleNameOutput[] = [];

  @action
  async create(createUserInput: CreateOrUpdateUserInput) {
    let result = await userService.create(createUserInput);
    this.users.items.push(result);
  }

  @action
  async update(updateUserInput: UpdateUserInput) {
    let result = await userService.update(updateUserInput);
    if(this.users) {
      this.users.items = this.users.items.map((x: GetUserOutput) => {
        if (x.id === updateUserInput.id) x = result;
        return x;
      });
    }
  }

  @action
  async delete(entityDto: EntityDto) {
    await userService.delete(entityDto);
    this.users.items = this.users.items.filter((x: GetUserOutput) => x.id !== entityDto.id);
  }

  @action
  async unDisabled(entityDto: EntityDto) {
    await userService.unDisabledUser(entityDto);
    this.users.items = this.users.items.filter((x: GetUserOutput) => x.id !== entityDto.id);
  }

  @action
  async getRoles() {
    let result = await userService.getRoles();
    this.roles = result;
  }

  @action
  async get(entityDto: EntityDto) {
    let result = await userService.get(entityDto);
    this.editUser = result;
  }

  @action
  async createUser() {
    this.editUser = {
      customerInfoCusNo: '',
      salesCusNos: [],
      userName: '',
      name: '',
      surname: '',
      emailAddress: '',
      isActive: false,
      roleNames: [],
      password: '',
      id: 0,
    };
    this.roles = [];
  }

  @action
  async getAll(pagedFilterAndSortedRequest: PagedUserResultRequestDto) {
    let result = await userService.getAll(pagedFilterAndSortedRequest);
    this.users = result;
  }

  async changeLanguage(languageName: string) {
    await userService.changeLanguage({ languageName: languageName });
  }
  @action
  async getUserIdAndNamesByUserIds(userids?: number[]) {
    this.userIdAndNamesByUserIds = await this.userServiceProxy.getUserIdAndNamesByUserIds(userids);
  }
  private getUserIdAndNamesByLikeNameDebounced = debounce(async (roleNames?: string[], name?: string) => {
    this.userIdAndNamesyLikeName = await this.userServiceProxy.getUserIdAndNamesByLikeName(roleNames, name);
  }, 500);
  @action getUserIdAndNamesByLikeName(roleNames?: string[], name?: string) {
    this.getUserIdAndNamesByLikeNameDebounced(roleNames, name);
  }

  @action
  async getUserByEmail(email: string) {
    return await this.userServiceProxy.getUserByEmail(email);
  }

  @action
  async excelUser(pagedFilterAndSortedRequest: PagedUserResultRequestDto) {
    let result = await userService.excelUser(pagedFilterAndSortedRequest);
    return result
  }
}

export default UserStore;
